import { Theme } from '@mui/material/styles';

export default function Tooltip(theme: Theme) {
  const isDark = theme.palette.mode === 'dark';
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '0.8rem',
          fontWeight: 500,
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.background.paper,
          backgroundImage: 'none',
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 8,
          padding: '6px 10px',
          boxShadow: isDark ? '0 6px 20px rgba(0, 0, 0, 0.5)' : '0 6px 20px rgba(15, 26, 46, 0.15)',
        },
        arrow: {
          color: theme.palette.background.paper,
          '&::before': {
            border: `1px solid ${theme.palette.divider}`,
          },
        },
      },
    },
  };
}
